import { backendEnv } from '../../env';
import './article_viewer.css';
import { forwardRef, useEffect, useState } from "react";
import { endpoints } from '../../env';
import { useServer } from '../../context/serverContext';

export const ArticleViewer = forwardRef(({selectedArticle}, ref) => {

    const { postRequest } = useServer();
    const [source, setSource] = useState(null);
    const [source2, setSource2] = useState(null);
    const [playStartTime, setPlayStartTime] = useState(null);
    const [pauseEndTime, setPauseEndTime] = useState(null);
  
    const handlePlay = () => {
        setPlayStartTime(true);
    };
      
    const handlePause = () => {
        setPauseEndTime(true);
        console.log("pause");
     };
      
    useEffect(() => {
        const handlePostRequest = () => {
            if (playStartTime !== null) {
                let data = {
                    article_id: selectedArticle.id,
                    time: 1,
                };
                postRequest(endpoints.updateTime, data, (res) => {
                if (res[0]) {
                  //  console.log("update");
                } 
              });
            }
        };
        const intervalId = setInterval(handlePostRequest, 60000);
        return () => clearInterval(intervalId);
      }, [playStartTime, postRequest, selectedArticle]);

      useEffect(() => {
        if (pauseEndTime !== null) {
          setPlayStartTime(null);
          setPauseEndTime(null);
        }
      }, [pauseEndTime, playStartTime]);


    useEffect(() => {

        if (selectedArticle && selectedArticle.type === 0) {
            setSource(
                <video onPlay={handlePlay} onPause={handlePause} onEnded={handlePause}  onAbort={handlePause} className="" width="100%" height="100%" controls controlsList='nodownload' key={"video_player_" + selectedArticle.id}>
                    <source src={backendEnv.url + "/api/public/v1/article/"+selectedArticle.id+"/video/get"} type="video/mp4" key={backendEnv.url + "/api/public/v1/article/"+selectedArticle.id+"/video/get"} />);
                </video>
            );
        }

        if (selectedArticle && selectedArticle.type === 1) {
           // console.log(selectedArticle);
            setSource2(
                <video onPlay={handlePlay}
                onPause={handlePause} onEnded={handlePause}  onAbort={handlePause} className="" width="100%" height="100%" controls controlsList='nodownload' key={selectedArticle.content + "_" + selectedArticle.id} >
                    <source src={selectedArticle.content} type="video/mp4" key={selectedArticle.content} />
                </video>
            );
        }
    }, [selectedArticle]);
    
    if (selectedArticle) {
        return (
            <div className='article_viewer video'>
                {
                    selectedArticle.type === 1 && source2
                }
                {
                    selectedArticle.type === 0 && source
                }
                {
                    selectedArticle.type === 3 && (
                        <iframe
                            title="Selected Article"
                            frameBorder={0}
                            width="100%"
                            height="400px"
                            key={selectedArticle.id + "_iframe"}
                            srcDoc={selectedArticle.content}
                        >
                            {}
                        </iframe>
                    )
                }
            </div>
        );
    } else {
        return <div className='article_viewer video'></div>
    }
    
});